import { CloudSun } from "lucide-react";
import type { GuestTabletDailyProgram, GuestTabletWeather } from "@/types/guestTablet";

type Props = {
  weather: GuestTabletWeather;
  program: GuestTabletDailyProgram;
};

export function TabletWeatherProgram({ weather, program }: Props) {
  return (
    <section className="guest-tablet-card p-6 md:p-8">
      <h2 className="guest-tablet-section-title mb-6">Heute bei uns</h2>
      <div className="grid gap-6 lg:grid-cols-2">
        <div className="flex items-start gap-4 rounded-xl bg-sky-900/5 p-5 dark:bg-sky-400/10">
          <CloudSun className="h-12 w-12 shrink-0 text-sky-600" />
          <div>
            <p className="text-4xl font-bold">{Math.round(weather.temperature_c)}°</p>
            <p className="text-lg capitalize text-label-secondary">{weather.condition}</p>
            <p className="mt-1">{weather.description}</p>
            {weather.provider === "mock" && (
              <p className="mt-2 text-sm text-label-tertiary">Wetter-Vorschau (Demo)</p>
            )}
          </div>
        </div>

        <div>
          <p className="text-lg font-medium leading-relaxed">{program.today_hint}</p>
          {program.special_info && (
            <p className="mt-3 rounded-lg bg-amber-900/5 px-3 py-2 text-base dark:bg-amber-400/10">
              {program.special_info}
            </p>
          )}
        </div>
      </div>

      <div className="mt-8 grid gap-6 md:grid-cols-2">
        <div>
          <h3 className="mb-3 text-base font-semibold uppercase tracking-wide text-label-secondary">
            Tagesprogramm
          </h3>
          <ul className="space-y-3">
            {program.schedule.map((item) => (
              <li key={`${item.time}-${item.title}`} className="flex gap-3 text-lg">
                <span className="w-14 shrink-0 font-semibold tabular-nums text-emerald-800 dark:text-emerald-300">
                  {item.time}
                </span>
                <span>
                  {item.title}
                  {item.location && (
                    <span className="block text-base text-label-secondary">{item.location}</span>
                  )}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="mb-3 text-base font-semibold uppercase tracking-wide text-label-secondary">
            Veranstaltungen
          </h3>
          <ul className="space-y-3">
            {program.events.map((ev) => (
              <li key={ev.title} className="rounded-lg bg-emerald-900/5 px-3 py-2 dark:bg-white/5">
                <p className="font-semibold">{ev.title}</p>
                {ev.note && <p className="text-base text-label-secondary">{ev.note}</p>}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
